import React, { useContext, useEffect, useState, useRef } from "react";
import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  TooltipHost,
} from "@fluentui/react";
import themeContext from "../../../../../context/theme/ThemeContext";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import {
  changeSortDir,
  clearSort,
  handleDropDownClick,
  handleDropDownClickCustom,
} from "../../../helpers/helpingFunctions";
import { t } from "i18next";
import { dropdownStyles } from "../../../helpers/initData";
import { REPORTED_SUBTABS_ID, USERTYPES } from "../../../../../constants/Constants";

const SortFilter = () => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    patientNameBadgeShow,
    removeBadgeFromFilter,
    setPatientDetail,
    handleEnterKeyPress,
    setSortGlobal,
    sortGlobal,
    selectedValue,
    changeToDropSorting, setChangeToDropSorting,
    roles
  } = useContext(studylistContext);

  const { themeName } = useContext(themeContext);
  const [isHoveringOnSort, setIsHoveringOnSort] = useState(false);
  const dropdownRef = useRef();
  const onSetFocus = () => dropdownRef?.current?.focus(true);

  const getColumnLabel = (keyStr) => {
    const options = sortOptionsFunction()
    const result = options.find(({ key }) => key === keyStr);
    if(result == null){
      return t("sorting.study-list.created-on");
    }
    return result?.text;
  };
  const handleMouseEnter = () => {
    setIsHoveringOnSort(true);
  };

  const handleMouseLeave = () => {
    setIsHoveringOnSort(false);
  };

  const sortOptionsFunction = () => {
    let options = [
      { key: "emergency_status", text: t("sorting.study-list.emergency-status") },
      { key: "patient_name", text: t("sorting.study-list.patient-name") },
     // { key: "reporting_provider", text: t("sorting.study-list.radiologist") },
      { key: "patient_id", text: t("sorting.study-list.patient-id") },
      { key: "study_date", text: t("sorting.study-list.study-date") },
      { key: "modality_name", text: t("sorting.study-list.modality") },
      { key: "client_name", text: t("sorting.study-list.hospital") },
      { key: "study_description", text: t("sorting.study-list.description") },
      { key: "assignment_created_date", text: t("sorting.study-list.created-on") },
    ]
    if (roles[0] === USERTYPES.TYPIST) {
      options = options.filter(option => option.key !== "client_name");
  }
  
    if (REPORTED_SUBTABS_ID.includes(selectedValue)) {
      options.push( { key: "report_submitted_date", text: t("sorting.study-list.reported-date") });
    }
    if(selectedValue == "study_5" || selectedValue == "study_24"){
        options.push({ key: "qc_review", text: t("sorting.study-list.qc-review") })
    }
    if(selectedValue == "study_6"){
      options.push({ key: "qc_fix", text: t("sorting.study-list.qc-fix") })
    }
    if(selectedValue == "study_7"){
      options.push({ key: "qc_review", text: t("sorting.study-list.qc-review") })
      options.push({ key: "qc_verify", text: t("sorting.study-list.qc-verify") })
    }
    if(selectedValue == "study_14"){
      options.push( { key: "review_assigned_date", text: t("sorting.study-list.review-assigned-date") })
    }
    if(selectedValue == "study_15"){
      options.push( { key: "review_completed_date", text: t("sorting.study-list.review-completed-date") })
    }
    if(selectedValue == "study_16"){
      options.push( { key: "evaluation_assigned_date", text: t("sorting.study-list.evaluator-assigned-date") })
    }
    if(selectedValue == "study_17"){
      options.push( { key: "evaluation_completion_date", text: t("sorting.study-list.evaluation-completed-date") })
    }
    if(selectedValue == "study_18"){
      options.push( { key: "requested_date", text: t("sorting.study-list.requested-date") })
    }
    if(selectedValue == "study_19"){
      options.push( { key: "approved_date", text: t("sorting.study-list.approved-date") })
    }
    if(selectedValue == "study_20"){
      options.push( { key: "requested_date2", text: t("sorting.study-list.requested-date") })
    }

    return options;
   
  }

  useEffect(()=>{
      if(changeToDropSorting){
        onSetFocus();
      }
  },[changeToDropSorting])

  const onRenderOption = (option) => {
    const isEmergency = option.key === "emergency_status";
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
        }}
      >
        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginRight: 8 }}>
          {option.text}
        </span>
        {!isEmergency && (
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flex: '0 0 auto' }}>
          <Icon
            onClick={(e) => {
              e.stopPropagation();
              handleDropDownClickCustom(e, option, setSortGlobal, sortGlobal,setChangeToDropSorting,false)
            }}
            iconName={"SortDown"}
            aria-hidden="true"
            style={{ cursor: 'pointer' }}
          />
          <Icon
            onClick={(e) => {
              e.stopPropagation();
              handleDropDownClickCustom(e, option, setSortGlobal, sortGlobal,setChangeToDropSorting,true)
            }}
            iconName={"SortUp"}
            aria-hidden="true"
            style={{ cursor: 'pointer' }}
          />
        </div>
        )}
      </div>
    );
  };



  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center"
        }}
      >
        {changeToDropSorting ? (
          <Dropdown
            componentRef={dropdownRef}
            options={sortOptionsFunction()}
            placeholder={`Sort by : ${getColumnLabel(sortGlobal.sortColumn)}`}
            onChange={(e, data) =>
              handleDropDownClick(e, data, setSortGlobal, sortGlobal,setChangeToDropSorting)
            }
             styles={{
              ...dropdownStyles,
                 dropdown: {
              ...dropdownStyles?.dropdown,
              width: 240,
              minWidth: 240,
              flexShrink: 0, 
              marginRight: '5px'
            },

              placeholder: {
                fontSize: '14px !important',
                color: '#A19F9D !important',
              },
              title: {
                ...dropdownStyles.title,
                position: 'relative',
                paddingRight: '30px',
                fontSize: sortGlobal.sortColumn ? '14px' : '14px',
              },
            }}
            onRenderCaretDown={() => (
              <div style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                <Icon iconName="ChevronDownMed" />
              </div>
            )}
            onRenderOption={onRenderOption}
            onDismiss={()=>{setChangeToDropSorting(false)}}
          />
        ) : (
          <div  style={{
            background: themeName === "light" ? '' : 'black',
            minWidth: '240px',
            width: '240px',
            height: '32px',
            flexShrink: '0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center', 
            padding: '0 4px',
            boxSizing: 'border-box',
            border: '1px solid rgb(88, 88, 88)',
            borderRadius: '7px',
            marginRight: '5px'
            }}  
            className="study-list-badge-list-view" >
              <span className="study-list-badge-text-list-view-no-hover" style={{ flex: '0 1 auto', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '14px' }}>
                Sort by : {getColumnLabel(sortGlobal.sortColumn)}
              </span>
              <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
              {sortGlobal.sortColumn !== "emergency_status" && (
              <Icon
                onClick={() => changeSortDir(setSortGlobal, sortGlobal,setChangeToDropSorting)}
                style={{
                  cursor: "pointer",
                  margin: 0,
                  backgroundColor: `${isHoveringOnSort ? "rgb(134, 158, 181, 0.5)" : ""}`,
                  borderRadius: "4px",
                  transition: "0.2s",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: '0 4px'
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                iconName={sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown"}
                className="ms-fontSize-10"
              />
              )}
              <Icon
                onClick={() => clearSort(setSortGlobal, sortGlobal, setChangeToDropSorting)}
                style={{ cursor: "pointer", margin: 0, padding: '0 4px' }}
                iconName="ChevronDownMed"
                className="ms-fontSize-10"
              />
              </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SortFilter;
